export const trackingEvents = {
  STOP: {
    CLICKED: 'employer_commission_detail.stop.clicked',
  },
  NEW: {
    CLICKED: 'employer_commission_detail.new.clicked',
  },
}
